module.exports = __webpack_public_path__ + "img/new4.b69e93da.png";